enum ProjectRole {
    ADMINISTRATOR = 'ADMINISTRATOR',
    EDITOR = 'EDITOR',
}

export default ProjectRole;
